import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {GlobalVariable} from './../global';
import { MsalTokenService } from './msal-token.service';

@Injectable({
  providedIn: 'root'
})
export class SssoreqService {
  private baseUrl: string = GlobalVariable.BASE_URL;   
  constructor(private http: HttpClient, private msalToken: MsalTokenService) { }
  
  async  testSso() {

    const token = await this.msalToken.getToken();
    if (!token) return;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      auth_type: 'SSO',      // or whatever value you need
      'Accept-Language': 'ja-JP'             // for example 'en', 'jp', 'fr'
    });

    let apiUrl = this.baseUrl+'/test/';

    return this.http.get <any>(apiUrl, { headers });
  }
  
}
